import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
    FaPlusCircle, 
    FaClipboardList, 
    FaCheckDouble,
    FaChevronRight
} from 'react-icons/fa';

const ActionCard = ({ title, description, icon, color, onClick, topBorderColor }) => (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden flex flex-col hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group">
        <div className={`h-1.5 w-full ${topBorderColor}`}></div>
        <div className="p-8 flex flex-col items-center text-center flex-grow">
            <div className={`w-16 h-16 ${color} rounded-2xl flex items-center justify-center text-white mb-6 shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                {React.cloneElement(icon, { size: 28 })}
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-emerald-600 transition-colors uppercase tracking-tight font-marathi">{title}</h3>
            <p className="text-sm text-gray-400 font-bold uppercase tracking-wider font-marathi">{description}</p>
        </div>
        <div 
            className="px-8 py-5 border-t border-gray-50 flex items-center justify-between cursor-pointer hover:bg-emerald-50/30 transition-colors" 
            onClick={onClick}
        >
            <span className="text-xs font-black text-gray-400 group-hover:text-emerald-600 transition-colors uppercase tracking-[0.2em] font-marathi">निवडा</span>
            <div className="w-8 h-8 rounded-full bg-gray-50 flex items-center justify-center group-hover:bg-emerald-100 transition-colors">
                <FaChevronRight className="text-gray-300 group-hover:text-emerald-500 transition-colors text-[10px]" />
            </div>
        </div>
    </div>
);

const ZpHeadWorkMenu = () => {
    const navigate = useNavigate();

    const options = [
        {
            title: "कामाची यादी करा",
            description: "नवीन काम समाविष्ट करा",
            icon: <FaPlusCircle />,
            color: "bg-[#085e53]", 
            topBorderColor: "bg-[#085e53]",
            path: "/zp-head/work-info/list" 
        },
        {
            title: "नवीन कामाची यादी",
            description: "सर्व कामांची यादी पहा",
            icon: <FaClipboardList />,
            color: "bg-[#3b82f6]", 
            topBorderColor: "bg-[#3b82f6]",
            path: "/zp-head/work-info/new"
        },
        {
            title: "लॉटरी कम्प्लिटेड कामाची यादी",
            description: "लॉटरी पूर्ण झालेली कामे",
            icon: <FaCheckDouble />,
            color: "bg-[#f59e0b]", 
            topBorderColor: "bg-[#f59e0b]",
            path: "/zp-head/work-info/lottery-completed"
        }
    ];

    return (
        <div className="min-h-[80vh] flex flex-col p-4 md:p-8">
            {/* Header Section */}
            <div className="bg-[#1a1c23] rounded-[1.25rem] p-10 mb-12 flex flex-col md:flex-row justify-between items-center shadow-xl relative overflow-hidden">
                <div className="relative z-10">
                    <h1 className="text-4xl font-black text-white mb-2 font-marathi">
                        कामाची माहिती <span className="font-bold text-emerald-400">(Work Info)</span>
                    </h1>
                    <p className="text-gray-400 text-sm font-medium font-marathi">
                        कामाची व्यवस्था करण्यासाठी खालील पर्यायांवर क्लिक करा
                    </p>
                </div>
                
                <button 
                    onClick={() => navigate(-1)}
                    className="mt-6 md:mt-0 bg-[#2d2f39] hover:bg-[#383a45] text-white px-8 py-3 rounded-xl font-bold text-sm transition-all duration-300 active:scale-95 shadow-lg border border-white/5 font-marathi flex items-center gap-2"
                >
                    मागे जा
                </button>
            </div>

            {/* Cards Grid */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto w-full px-4">
                {options.map((option, index) => (
                    <ActionCard 
                        key={index}
                        {...option}
                        onClick={() => navigate(option.path)}
                    />
                ))}
            </div>

            <style>{`
                .font-marathi {
                    font-family: 'Hind', sans-serif;
                }
                @import url('https://fonts.googleapis.com/css2?family=Hind:wght@400;500;600;700&display=swap');
            `}</style>
        </div>
    );
};

export default ZpHeadWorkMenu;
